import type { Entry } from 'contentful';

import type { Container as ContainerEntry } from '../../../types/spaces/ecommerce-petsmart';
import type { MapEntry } from '../../../utils/map-entries';
import type { ContainerProps } from './types';

export function transformContainer(entry: ContainerEntry, map: MapEntry): ContainerProps {
    return {
        roundTopCorners: !entry.fields.topOfPage,
        items: (entry.fields.items ?? []).map(item => map(item as Entry)).filter(item => item !== null),
    };
}
